<template>
  <div>
    <div
      class="overlay"
      :class="{ 'overlay-visible': isSidebarOpen }"
      @click="closeSidebar"
    ></div>
    <div class="sidebar" :class="{ 'sidebar-mobile-open': isSidebarOpen }">
      <div class="sidebar-brand">
        <img
          src="https://cdn0.archipelagointernational.com/v3/assets/images/brand/archipelago-new-logo-2.svg"
          alt="Archipelago International"
          class="sidebar-logo"
        />
        <button class="sidebar-close-btn" @click="toggleSidebar">
          <i class="material-icons">close</i>
        </button>
      </div>
      <nav class="sidebar-nav">
        <ul>
          <li>
            <router-link to="/dashboard" class="sidebar-link" exact-active-class="active"
              ><i class="material-icons">home</i> Home</router-link
            >
          </li>
          <li class="sidebar-dropdown">
            <a
              href="#"
              class="sidebar-link dropdown-toggle"
              :class="{ 'active': isArticleRouteActive }"
              @click.prevent="toggleArticleMenu"
              ><i class="material-icons">library_books</i> List of Articles
              <i
                class="material-icons dropdown-icon"
                :class="{ rotate: showArticleMenu }"
                >keyboard_arrow_down</i
              ></a
            >
            <ul class="sidebar-submenu" :class="{ expanded: showArticleMenu }">
              <li v-for="group in groups" :key="group.GroupID">
                <a
                  @click.prevent="navigateToGroup(group.GroupID)"
                  class="sidebar-sublink"
                  :class="{ 'active': $route.params.groupId === group.GroupID.toString() }"
                >{{ group.GroupName }}</a>
              </li>
            </ul>
          </li>
          <li>
            <router-link to="/news" class="sidebar-link" active-class="active"
              ><i class="material-icons">notifications</i> News &
              Updates</router-link
            >
          </li>
          <!-- <li>
            <router-link to="/it-contact-list" class="sidebar-link" active-class="active"
              ><i class="material-icons">contact_phone</i> IT Contact
              List</router-link
            >
          </li> -->
          <li class="sidebar-logout">
            <a @click="handleLogout" class="sidebar-link"
              ><i class="material-icons">exit_to_app</i> Logout</a
            >
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import router from "../router";

export default {
  name: 'SideBar',
  props: {
    groups: {
      type: Array,
      default: () => []
    },
    isSidebarOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showArticleMenu: false
    };
  },
  computed: {
    isArticleRouteActive() {
      return this.$route.path.includes('/article/');
    }
  },
  methods: {
    toggleArticleMenu() {
      this.showArticleMenu = !this.showArticleMenu;
    },
    navigateToGroup(groupId) {
      // Close the sidebar on mobile
      if (window.innerWidth <= 768) {
        this.closeSidebar();
      }
      
      // Get current and target routes
      const currentRoute = this.$route;
      const targetRoute = {
        name: 'ArticleList',
        params: { groupId: groupId.toString() }
      };
      
      // If we're already on this route, force a refresh of the data
      if (currentRoute.name === targetRoute.name && 
          currentRoute.params.groupId === targetRoute.params.groupId) {
        // Emit a custom event that ArticleList can listen for
        this.$root.$emit('refresh-article-groups');
        
        // Also use the router to force a refresh
        this.$router.replace({ path: '/article/' + groupId, query: { _: Date.now() } });
      } else {
        // Normal navigation for different routes
        this.$router.push(targetRoute);
      }
    },
    toggleSidebar() {
      this.$emit('toggle-sidebar');
    },
    closeSidebar() {
      this.$emit('close-sidebar');
    },
    handleLogout() {
      this.$emit('handle-logout');
    }
  },
  watch: {
    '$route'() {
      // Automatically expand the article menu if on an article page
      if (this.isArticleRouteActive && !this.showArticleMenu) {
        this.showArticleMenu = true;
      }
    }
  },
  created() {
    // Initially expand the article menu if on an article page
    if (this.isArticleRouteActive) {
      this.showArticleMenu = true;
    }
  }
};
</script>

<style scoped>
.overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 0.3s ease;
  opacity: 0;
}

.overlay-visible {
  display: block;
  opacity: 1;
}

.sidebar {
  width: 250px;
  height: 100%;
  background: #132f53;
  color: #fff;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  font-family: 'Zen Kaku Gothic New', sans-serif;
}

.sidebar-brand {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background-color: #0d233e;
  position: relative;
}

.sidebar-logo {
  max-width: 180px;
  height: auto;
  filter: brightness(0) invert(1);
}

.sidebar-nav {
  padding: 5px 0;
  flex-grow: 1;
  overflow-x: hidden; /* Prevent horizontal scrolling */
}

.sidebar-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.sidebar-nav li {
  margin-bottom: 1px;
  width: 100%;
}

.sidebar-submenu li {
  margin-bottom: 2px;
}

.sidebar-link {
  display: flex;
  align-items: center;
  padding: 8px 20px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s;
  border-left: 3px solid transparent;
  font-weight: 500;
  height: 40px;
  width: calc(100% - 3px); /* Account for border-left to prevent overflow */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar-link i {
  margin-right: 15px;
}

.sidebar-link.dropdown-toggle:hover {
  color: #fff;
}

.sidebar-submenu {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease;
  background-color: #0d233e;
}

.sidebar-submenu.expanded {
  max-height: 600px;
}

.sidebar-sublink {
  display: flex;
  align-items: flex-start;
  padding: 8px 20px 8px 50px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: all 0.2s;
  font-size: 0.95em;
  min-height: 36px;
  height: auto;
  max-height: none; /* Remove max-height restriction to prevent clipping */
  width: calc(100% - 10px); /* Slightly reduce width to prevent overflow */
  overflow: hidden;
  line-height: 1.4; /* Slightly increase line height for better readability */
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* Allow up to 3 lines of text */
  -webkit-box-orient: vertical;
  line-clamp: 3;
  border-left: 3px solid transparent;
  padding-top: 10px;
  padding-bottom: 10px; /* Increase padding to give more space */
}

.sidebar-sublink:hover,
.sidebar-sublink.active {
  background: rgba(21, 101, 192, 0.15);
  color: #fff;
  border-left-color: #1565c0;
  transform: translateX(3px);
  transition: transform 0.3s ease, background 0.3s ease, color 0.3s ease, border-left-color 0.3s ease;
}

.sidebar-link:hover,
.sidebar-link.active,
.sidebar-link.dropdown-toggle:hover {
  background: rgba(21, 101, 192, 0.15);
  color: #fff;
  border-left-color: #1565c0;
  transform: translateX(3px);
  transition: transform 0.3s ease, background 0.3s ease, color 0.3s ease, border-left-color 0.3s ease;
}

.sidebar-logout {
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 10px;
  margin-top: 30px;
}

.sidebar-close-btn {
  display: none;
  background: none;
  border: none;
  color: #fff;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.sidebar-close-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Add styles for dropdown icon rotation */
.dropdown-icon {
  margin-left: auto;
  margin-right: 0;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.dropdown-icon.rotate {
  transform: rotate(180deg);
}

@media (max-width: 768px) {
  .sidebar {
    width: 280px;
    height: 100%;
    position: fixed;
    left: -280px;
    top: 0;
    z-index: 1000;
    transition: left 0.3s ease;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    font-family: 'Zen Kaku Gothic New', sans-serif;
  }

  .sidebar-mobile-open {
    left: 0;
  }

  .sidebar-nav {
    padding: 10px 0;
  }

  .sidebar-link {
    height: 44px;
    padding: 10px 15px;
  }

  .sidebar-sublink {
    min-height: 40px;
    max-height: 56px;
    padding: 8px 20px 8px 50px;
  }

  .sidebar-close-btn {
    display: block;
  }
}

@media (max-width: 992px) {
  .sidebar {
    width: 275px;
  }

  .sidebar-close-btn {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SideBar.vue